// Tekst za pretragu: ćirilica → latinica, mala slova, bez kvačica (ć, č, š, ž, đ → c, c, s, z, dj).
// "Извештај", "Izveštaj" i "izvestaj" daju isti rezultat.
const convert = require("cyrillic-to-latin");

export function normText(value) {
  return convert(String(value == null ? "" : value))
    .toLowerCase()
    .replace(/đ/g, "dj")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "");
}

// Svaka riječ upita mora biti u tekstu ("izv gost" nalazi "Izveštaj Gost").
export function matchesText(text, query) {
  const q = normText(query).trim();
  if (!q) return true;
  const hay = normText(text);
  return q.split(/\s+/).every((token) => hay.indexOf(token) > -1);
}
